import * as React from "react";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { QueryStateBoundary } from "@/components/dashboard/QueryStateBoundary";
import { CapabilityGrid } from "../CapabilityGrid";
import { useBrokerCapabilities } from "@/hooks/queries/useBrokerStatus";

interface CapabilitiesPayload {
  capabilities: Record<string, string[]>;
}

export function CapabilitiesSection(): React.JSX.Element {
  const capabilitiesQuery = useBrokerCapabilities();

  return (
    <StatusCard title="Capabilities">
      <QueryStateBoundary
        query={capabilitiesQuery}
        isEmpty={(data) =>
          Object.keys((data as unknown as CapabilitiesPayload).capabilities ?? {}).length === 0
        }
        emptyMessage="No capabilities reported by the backend."
      >
        {(payload) => (
          <CapabilityGrid
            capabilitiesByProvider={(payload as unknown as CapabilitiesPayload).capabilities}
          />
        )}
      </QueryStateBoundary>
    </StatusCard>
  );
}
